const PLAN_SLUGS = ['free', 'basic', 'premium', 'enterprise'];

export default function PlansPanel({ plans, onChange }) {
  const updatePlan = (slug, patch) => {
    onChange({
      ...plans,
      [slug]: { ...plans[slug], ...patch },
    });
  };

  return (
    <section className="chart-card economics-panel">
      <h2>Plan prices & bank link</h2>
      <p className="chart-hint">Monthly subscription price and whether tier can Link (Free = manual only).</p>
      <div className="table-scroll">
        <table className="data-table economics-plans-table">
          <thead>
            <tr>
              <th>Tier</th>
              <th>Monthly ($)</th>
              <th>Bank link</th>
              <th>Entities max</th>
              <th>Accounts max</th>
            </tr>
          </thead>
          <tbody>
            {PLAN_SLUGS.map((slug) => {
              const plan = plans[slug];
              if (!plan) return null;
              return (
                <tr key={slug}>
                  <td>{plan.name}</td>
                  <td>
                    <input
                      className="economics-inline-input"
                      type="number"
                      min="0"
                      step="0.01"
                      value={plan.monthly}
                      onChange={(e) =>
                        updatePlan(slug, {
                          monthly: Math.max(0, parseFloat(e.target.value) || 0),
                        })
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      checked={Boolean(plan.bankLink)}
                      onChange={(e) => updatePlan(slug, { bankLink: e.target.checked })}
                    />
                  </td>
                  <td>
                    <input
                      className="economics-inline-input"
                      type="number"
                      min="0"
                      placeholder="∞"
                      value={plan.entitiesMax ?? ''}
                      onChange={(e) =>
                        updatePlan(slug, {
                          entitiesMax:
                            e.target.value === ''
                              ? null
                              : Math.max(0, parseInt(e.target.value, 10) || 0),
                        })
                      }
                    />
                  </td>
                  <td>
                    <input
                      className="economics-inline-input"
                      type="number"
                      min="0"
                      placeholder="∞"
                      value={plan.accountsMax ?? ''}
                      onChange={(e) =>
                        updatePlan(slug, {
                          accountsMax:
                            e.target.value === ''
                              ? null
                              : Math.max(0, parseInt(e.target.value, 10) || 0),
                        })
                      }
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
